@if (!isSidebarLoading()) {
  <div class="h-full flex flex-col">
    <app-sidebar-header
      [showBackButton]="!isEdit || (currentPage$ | async) !== COMMITMENT_SIDEBAR_PAGE.FIRST_PAGE"
      (backButtonClicked)="goBack()"
    >
      <div smallTitle>{{ isEdit ? 'Edit Direct Cost' : 'Add Direct Cost' }}</div>
      @if ((currentPage$ | async) === COMMITMENT_SIDEBAR_PAGE.FIRST_PAGE) {
        <div mainTitle>General Information</div>
      }
    </app-sidebar-header>
    <ng-scrollbar
      [ngClass]="{ 'first-page': (currentPage$ | async) === COMMITMENT_SIDEBAR_PAGE.FIRST_PAGE }"
      class="std-scrollbar wider-track"
      appearance="compact"
      orientation="vertical"
    >
      <div
        [ngClass]="{ 'mx-7 mt-5': (currentPage$ | async) === COMMITMENT_SIDEBAR_PAGE.FIRST_PAGE }"
        class="scrollable-content mb-5"
      >
        @if ((currentPage$ | async) === COMMITMENT_SIDEBAR_PAGE.FIRST_PAGE) {
          <form class="flex flex-col flex-1" #firstPageForm="ngForm" role="form" [@fadeInGeneral]>
            <div class="flex-1 flex flex-col">
              <app-upload-commitments-sidebar
                [commitmentType]="COMMITMENTS_INTERACTION_BAR_TYPE.DIRECT_COST"
              ></app-upload-commitments-sidebar>
              <app-floating-input
                [required]="true"
                [(ngModel)]="model.vendor"
                label="Vendor Name"
                name="vendor"
                (change)="updateDirectCost()"
              >
              </app-floating-input>
              <div class="two-input-row">
                <app-floating-input
                  [required]="true"
                  name="title"
                  [(ngModel)]="model.title"
                  label="Direct Cost Title"
                  (change)="updateDirectCost()"
                >
                </app-floating-input>
                <app-dropdown
                  [required]="true"
                  name="paid_status"
                  [(ngModel)]="model.paid_status"
                  [options]="paidStatuses"
                  (ngModelChange)="updateDirectCost()"
                  label="Direct Cost Status"
                >
                  <ng-template let-status #optionContent>
                    @if (status) {
                      <div [ngClass]="status.value ? 'text-navy-900' : 'text-navy-600'" class="capitalize text-medium">
                        {{ status.text }}
                      </div>
                    }
                  </ng-template>
                  <ng-template let-status #selectedContent>
                    @if (status) {
                      <div [ngClass]="status.value ? 'text-navy-900' : 'text-navy-600'" class="capitalize text-medium">
                        {{ status.text }}
                      </div>
                    }
                  </ng-template>
                </app-dropdown>
              </div>
              <div class="two-input-row">
                <app-input-calendar
                  #added_at_calendar
                  [required]="true"
                  [date]="model.added_at"
                  [minStartDate]="projectData?.start_date"
                  (dateChanged)="updateAddedDate($event)"
                  placeholder="Direct Cost Date"
                  name="added_at"
                  [ngClass]="{
                    'col-span-2': !model.paid_status,
                  }"
                  [showIcon]="true"
                ></app-input-calendar>
                @if (model.paid_status) {
                  <app-input-calendar
                    #paid_calendar
                    [required]="true"
                    [date]="model.paid_date"
                    [minStartDate]="model?.added_at ?? projectData?.start_date"
                    (dateChanged)="updatePaidDate($event)"
                    placeholder="Paid Date"
                    name="paid_date"
                    [showIcon]="true"
                  ></app-input-calendar>
                }
              </div>
              <app-floating-textarea
                name="description"
                [(ngModel)]="model.description"
                (ngModelChange)="updateDirectCost()"
                label="Direct Cost Description"
              >
              </app-floating-textarea>
            </div>
          </form>
        } @else {
          <div [@fadeInGeneral]>
            @for (entry of spendEntriesData; track $index; let index = $index) {
              <div>
                <app-spend-entry
                  #spendEntries
                  [commitmentAddedAt]="model.added_at"
                  [model]="entry"
                  [projectData]="projectData"
                  [index]="index"
                  [commitmentType]="COMMITMENTS_INTERACTION_BAR_TYPE.DIRECT_COST"
                  [disableRemoveEntry]="spendEntriesData.length === 1"
                ></app-spend-entry>
              </div>
            }
            <div class="horizontal-spacing mt-5 mb-2">
              <app-simple-button
                size="large"
                [wrapperClass]="{
                  'border-2   bg-transparent w-full rounded-[3px] ': true,
                  'border-blue-700 text-blue-700': (canAddDirectCostEntries$ | async),
                  'border-navy-500 text-navy-500': !(canAddDirectCostEntries$ | async),
                }"
                (click)="addSpendEntry()"
                [disabled]="!(canAddDirectCostEntries$ | async)"
                >Add Spend Entry
              </app-simple-button>
            </div>
          </div>
        }
      </div>
    </ng-scrollbar>
    <div
      class="bottom-container"
      [ngClass]="{ bordered: (currentPage$ | async) === COMMITMENT_SIDEBAR_PAGE.LAST_PAGE }"
    >
      @if ((currentPage$ | async) === COMMITMENT_SIDEBAR_PAGE.LAST_PAGE) {
        <span class="text-navy-700 text-base font-bold flex-1 flex">
          <span class="flex-1">Total Direct Cost</span>
          <span class="flex-1 justify-center flex" [ngClass]="{ negative: (totalDirectCost$ | async) < 0 }">
            @if ((totalDirectCost$ | async) !== 0) {
              <span>{{ totalDirectCost$ | async | money: 'positiveComa' }}</span>
            }
            @if ((totalDirectCost$ | async) === 0) {
              <span>$ {{ totalDirectCost$ | async | number }}</span>
            }
          </span>
        </span>
      }
      <div>
        @if ((currentPage$ | async) === COMMITMENT_SIDEBAR_PAGE.FIRST_PAGE) {
          <app-simple-button
            [wrapperClass]="{
              rounded: true,
            }"
            (click)="incrementPage()"
            [disabled]="isLoading"
          >
            @if (!isLoading) {
              <span>Next</span>
            }
            @if (isLoading) {
              <span class="icon-refresh animate-spin"></span>
            }
          </app-simple-button>
        } @else {
          <app-simple-button
            (click)="save()"
            [disabled]="isLoading"
            [wrapperClass]="{
              'bg-yellow-500 rounded': true,
            }"
          >
            @if (!isLoading) {
              <span>Submit</span>
            }
            @if (isLoading) {
              <span class="icon-refresh animate-spin"></span>
            }
          </app-simple-button>
        }
      </div>
    </div>
  </div>
} @else {
  <div class="flex w-full h-full items-center justify-center">
    <app-loading-spinner></app-loading-spinner>
  </div>
}
